import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
interface CTAButtonProps {
  text?: string;
  subtext?: string;
  className?: string;
  href?: string;
  onClick?: () => void;
}
export function CTAButton({
  text = 'LOWER MY HOUSE PAYMENT NOW!',
  subtext = 'Secure checkout. Instant PDF access delivered to your email.',
  className = '',
  href,
  onClick
}: CTAButtonProps) {
  const handleClick = () => {
    if (href) {
      window.open(href, '_blank');
    } else {
      document.getElementById('offer')?.scrollIntoView({
        behavior: 'smooth'
      });
    }
    onClick?.();
  };
  return <div className={`flex flex-col items-center w-full ${className}`} data-id="element-1">
      <motion.button onClick={handleClick} className="w-full md:w-auto bg-red hover:bg-red-hover text-white font-bold text-lg md:text-xl py-4 px-8 rounded-md border-b-4 border-gold shadow-glow transition-colors duration-300 flex items-center justify-center gap-3" animate={{
      scale: [1, 1.03, 1],
      boxShadow: ['0 0 20px rgba(192, 57, 43, 0.4)', '0 0 35px rgba(192, 57, 43, 0.7)', '0 0 20px rgba(192, 57, 43, 0.4)']
    }} transition={{
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut'
    }} whileHover={{
      scale: 1.05
    }} whileTap={{
      scale: 0.98
    }} data-id="element-2">
        {text}
      </motion.button>
      {subtext && <div className="flex items-center gap-2 mt-3 text-sm text-gray-500 font-medium" data-id="element-3">
          <ShieldCheck className="w-4 h-4 text-green" data-id="element-4" />
          <span data-id="element-5">{subtext}</span>
        </div>}
    </div>;
}